module.exports = __webpack_public_path__ + "img/img1.e499b52f.png";